import { MessageCircle, ExternalLink } from "lucide-react";
import { TrendingUp } from "lucide-react";

const TrendingSection = ({ trending, articles, formatDate, onArticleClick }) => {
  if (trending.length === 0) return null;

  return (
    <div className="mb-6 sm:mb-8" data-testid="trending-section">
      <div className="flex items-center gap-2 mb-4">
        <TrendingUp className="w-5 h-5" style={{ color: "var(--color-accent)" }} />
        <h2 className="text-lg sm:text-xl font-black tracking-tight" style={{ color: "var(--color-text)", fontFamily: "Cabinet Grotesk, sans-serif" }}>
          Most Discussed
        </h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {trending.map((item, idx) => {
          const matchedArticle = articles.find(a => a.url === item.article_url);
          if (!matchedArticle) return null;
          return (
            <div key={item.article_url || idx}
              className="flex items-start gap-3 p-3 sm:p-4 rounded-xl text-left"
              style={{ backgroundColor: "var(--color-card)", border: "1px solid var(--color-border)" }}
              data-testid={`trending-item-${idx}`}>
              <span className="text-xl sm:text-2xl font-black shrink-0 w-7 sm:w-8 text-center" style={{ color: "var(--color-accent)" }}>
                {idx + 1}
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="text-xs sm:text-sm font-semibold leading-snug mb-1" style={{ color: "var(--color-text)", fontFamily: "Cabinet Grotesk, sans-serif" }}>
                  {matchedArticle.title}
                </h3>
                {matchedArticle.description && (
                  <p className="text-[11px] leading-relaxed mb-1.5 line-clamp-2" style={{ color: "var(--color-text-muted)" }}>
                    {matchedArticle.description}
                  </p>
                )}
                <button onClick={(e) => onArticleClick(matchedArticle, e)}
                  className="inline-flex items-center gap-1 text-[10px] sm:text-[11px] font-bold uppercase tracking-wide hover:underline mb-1 cursor-pointer"
                  style={{ color: "var(--color-accent)", background: "none", border: "none", padding: 0 }}
                  data-testid={`trending-read-more-${idx}`}>
                  Read More <ExternalLink className="w-3 h-3" />
                </button>
                <div className="flex items-center gap-2 text-[10px] sm:text-[11px]" style={{ color: "var(--color-text-dim)" }}>
                  <span className="font-semibold" style={{ color: "var(--color-live)" }}>{matchedArticle.source}</span>
                  <span>•</span>
                  <span className="flex items-center gap-1">
                    <MessageCircle className="w-3 h-3" />
                    {item.comment_count} {item.comment_count === 1 ? "comment" : "comments"}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TrendingSection;
